import { useState, useEffect } from 'react';
import { getSubscriptionsEnabled } from '../services/authService';
import MigracionChat from './MigracionChat';
import MenoresChat from './MenoresChat';
import EducacionChat from './EducacionChat';
import EmbarazoChat from './EmbarazoChat';
import LaboralChat from './LaboralChat';
import CasasChat from './CasasChat';
import JubilacionesChat from './JubilacionesChat';
import SaludChat from './SaludChat';
import EcommerceChat from './EcommerceChat';
import FalaBrasilChat from './FalaBrasilChat';

const ASESORES = [
  {
    id: 'falabrasil',
    icon: '🗣️',
    titulo: 'Fala Brasil',
    descripcion: 'Practica portugués para tu vida real: entrevistas, médico, banco, alquiler y un curso paso a paso.',
    componente: 'falabrasil',
    badge: 'PRÁCTICA DIARIA',
  },
  {
    id: 'migracion',
    icon: '🛂',
    titulo: 'Asesor Migratorio',
    descripcion: 'Refugio, RNM, CPF, CTPS, SUS, matrimonio y reunificación familiar (VITEM XI) para cubanos en Brasil.',
    componente: 'migracion',
    badge: '15 PREGUNTAS GRATIS',
  },
  {
    id: 'menores',
    icon: '👨‍👩‍👧',
    titulo: 'Menores y Familia',
    descripcion: 'Salida de menores de Cuba y casos en que una persona no puede salir del país, con lo que dice la Gaceta Oficial.',
    componente: 'menores',
    badge: 'PREGUNTAS GRATIS',
  },
  {
    id: 'educacion',
    icon: '🎓',
    titulo: 'Educación en Brasil',
    descripcion: 'Matrícula escolar, etapas del sistema educativo, revalidação de títulos y becas (ProUni, FIES).',
    componente: 'educacion',
  },
  {
    id: 'embarazo',
    icon: '🤰',
    titulo: 'Embarazo en Brasil',
    descripcion: 'Pré-natal en el SUS, parto, licencia de maternidad, salario maternidad y documentos del bebé.',
    componente: 'embarazo',
  },
  {
    id: 'laboral',
    icon: '💼',
    titulo: 'Derechos Laborales',
    descripcion: 'CLT, Carteira de Trabalho Digital, FGTS, horas extras, vacaciones y cómo denunciar abusos.',
    componente: 'laboral',
  },
  {
    id: 'casas',
    icon: '🏠',
    titulo: 'Comprar Casa en Brasil',
    descripcion: 'Financiamiento con la Caixa, Minha Casa Minha Vida, impuestos y proceso de escritura.',
    componente: 'casas',
  },
  {
    id: 'jubilaciones',
    icon: '👴',
    titulo: 'Jubilaciones y Adultos Mayores',
    descripcion: 'INSS, tipos de aposentadoria, BPC/LOAS y derechos del adulto mayor en Brasil.',
    componente: 'jubilaciones',
  },
  {
    id: 'salud',
    icon: '🏥',
    titulo: 'Salud en Brasil',
    descripcion: 'UBS, UPA y hospital, consultas en el SUS, Farmácia Popular y cartão do SUS.',
    componente: 'salud',
  },
  {
    id: 'ecommerce',
    icon: '🛍️',
    titulo: 'Vender en TikTok Shop y Shopee',
    descripcion: 'Productos ganadores, dropshipping y cómo empezar a vender online en Brasil.',
    componente: 'ecommerce',
  },
];

const PLANES = [
  { icon: '🎁', nombre: 'Free', nombreColor: 'var(--white)', desc: '5 preguntas por asesor (Migración: 15). En Menores: 5 al día y preguntas frecuentes gratis', precio: 'R$0', precioColor: 'var(--muted)' },
  { icon: '⭐', nombre: 'Pro', nombreColor: 'var(--orange)', desc: 'Ilimitado, checklist, 10% en Traducciones y más', precio: 'R$19,90/mes', precioColor: 'var(--orange)' },
];

function PlanesBanner() {
  return (
    <div style={{ marginBottom: 20 }}>
      <div style={{
        background: 'var(--navy-card)',
        border: '1px solid var(--navy-border)',
        borderRadius: 16,
        overflow: 'hidden',
      }}>
        {PLANES.map((p, i) => (
          <div
            key={p.nombre}
            style={{
              display: 'flex', alignItems: 'center', justifyContent: 'space-between',
              gap: 10, padding: '12px 16px',
              borderTop: i === 0 ? 'none' : '1px solid var(--navy-border)',
            }}
          >
            <div style={{ display: 'flex', alignItems: 'center', gap: 10, minWidth: 0 }}>
              <span style={{ fontSize: 18, flexShrink: 0 }}>{p.icon}</span>
              <div style={{ minWidth: 0 }}>
                <div style={{ color: p.nombreColor, fontSize: 13, fontWeight: 800 }}>{p.nombre}</div>
                <div style={{ color: 'var(--muted)', fontSize: 11.5, lineHeight: 1.4 }}>{p.desc}</div>
              </div>
            </div>
            <div style={{ color: p.precioColor, fontSize: 12.5, fontWeight: 700, flexShrink: 0, textAlign: 'right' }}>{p.precio}</div>
          </div>
        ))}
      </div>
      <div style={{ color: 'var(--muted)', fontSize: 11.5, textAlign: 'center', paddingTop: 8 }}>
        Entra y usa gratis — sin tarjeta, sin compromiso.
      </div>
    </div>
  );
}

export default function AsistentesScreen() {
  const [activo, setActivo] = useState(null);
  const [subscriptionsEnabled, setSubscriptionsEnabled] = useState(false);

  useEffect(() => {
    getSubscriptionsEnabled().then(setSubscriptionsEnabled);
  }, []);

  if (activo === 'falabrasil') return <FalaBrasilChat onBack={() => setActivo(null)} />;
  if (activo === 'migracion') return <MigracionChat onBack={() => setActivo(null)} />;
  if (activo === 'menores')   return <MenoresChat   onBack={() => setActivo(null)} />;
  if (activo === 'educacion') return <EducacionChat onBack={() => setActivo(null)} />;
  if (activo === 'embarazo')  return <EmbarazoChat  onBack={() => setActivo(null)} />;
  if (activo === 'laboral')   return <LaboralChat   onBack={() => setActivo(null)} />;
  if (activo === 'casas')     return <CasasChat     onBack={() => setActivo(null)} />;
  if (activo === 'jubilaciones') return <JubilacionesChat onBack={() => setActivo(null)} />;
  if (activo === 'salud')     return <SaludChat     onBack={() => setActivo(null)} />;
  if (activo === 'ecommerce') return <EcommerceChat onBack={() => setActivo(null)} />;

  const [featured, ...resto] = ASESORES;

  return (
    <div style={{
      minHeight: 'calc(100vh - 64px)',
      background: 'var(--bg)',
      padding: '24px 16px 100px',
    }}>
      {/* Encabezado */}
      <div style={{ marginBottom: 28 }}>
        <h1 style={{
          fontSize: 22, fontWeight: 900,
          color: 'var(--white)', marginBottom: 6,
        }}>🧠 Asesores</h1>
        <p style={{ fontSize: 13, color: 'var(--muted)', lineHeight: 1.5 }}>
          Orientación especializada para la comunidad cubana, disponible 24/7.
        </p>
      </div>

      {subscriptionsEnabled && <PlanesBanner />}

      {/* Destacado: Fala Brasil */}
      <button
        onClick={() => setActivo(featured.componente)}
        style={{
          width: '100%',
          background: 'linear-gradient(135deg, rgba(255,107,0,0.14), var(--navy-card) 55%)',
          border: '1px solid var(--orange)',
          borderRadius: 18,
          padding: '18px 16px',
          display: 'flex', alignItems: 'center', gap: 16,
          textAlign: 'left', cursor: 'pointer',
          marginBottom: 18,
        }}
      >
        <div style={{
          fontSize: 34, flexShrink: 0,
          background: 'rgba(255,107,0,0.18)',
          borderRadius: 14, width: 58, height: 58,
          display: 'flex', alignItems: 'center', justifyContent: 'center',
        }}>
          {featured.icon}
        </div>
        <div style={{ flex: 1, minWidth: 0 }}>
          {featured.badge && subscriptionsEnabled && (
            <div style={{
              display: 'inline-block', background: 'var(--orange)', color: 'var(--white)',
              fontSize: 10.5, fontWeight: 800, padding: '2px 8px', borderRadius: 10,
              marginBottom: 5, letterSpacing: 0.3,
            }}>
              {featured.badge}
            </div>
          )}
          <div style={{ fontSize: 16, fontWeight: 800, color: 'var(--white)', marginBottom: 4 }}>
            {featured.titulo}
          </div>
          <div style={{ fontSize: 12, color: 'var(--off-white)', lineHeight: 1.5 }}>
            {featured.descripcion}
          </div>
        </div>
        <span style={{ color: 'var(--orange)', fontSize: 20, flexShrink: 0 }}>›</span>
      </button>

      {/* Grilla de asesores */}
      <div style={{ color: 'var(--muted)', fontSize: 12, fontWeight: 700, letterSpacing: 0.4, marginBottom: 10, textTransform: 'uppercase' }}>
        Asesores por tema
      </div>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
        {resto.map((asesor, i) => {
          const isLastOdd = i === resto.length - 1 && resto.length % 2 === 1;
          return (
          <button
            key={asesor.id}
            onClick={() => setActivo(asesor.componente)}
            style={{
              background: 'var(--navy-card)',
              border: '1px solid var(--navy-border)',
              borderRadius: 16,
              padding: isLastOdd ? '14px 16px' : '16px 12px',
              display: 'flex',
              flexDirection: isLastOdd ? 'row' : 'column',
              alignItems: 'center',
              gap: isLastOdd ? 14 : 0,
              textAlign: isLastOdd ? 'left' : 'center',
              cursor: 'pointer',
              minHeight: isLastOdd ? 'auto' : 128,
              gridColumn: isLastOdd ? '1 / -1' : undefined,
            }}
          >
            <div style={{
              fontSize: 26, flexShrink: 0,
              background: 'rgba(244,121,32,0.12)',
              borderRadius: 12, width: 48, height: 48,
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              marginBottom: isLastOdd ? 0 : 8,
            }}>
              {asesor.icon}
            </div>
            <div style={{ fontSize: 13, fontWeight: 800, color: 'var(--white)', lineHeight: 1.3 }}>
              {asesor.titulo}
            </div>
            {asesor.badge && subscriptionsEnabled && (
              <div style={{
                display: 'inline-block', background: 'var(--success)', color: 'var(--white)',
                fontSize: 10, fontWeight: 700, padding: '2px 7px', borderRadius: 9,
                marginTop: 6,
              }}>
                {asesor.badge}
              </div>
            )}
          </button>
          );
        })}
      </div>
    </div>
  );
}
